import { Form, Space, Typography } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { memo, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { EyeIcon, MinusBordered, PlusBordered } from 'assets/svg';
import { ButtonAction } from 'components';
import TableComponent from 'components/Table/TableComponent';
import { ColumnsTypeCustom } from 'interfaces/Table/ColumnType';
import Content from 'layouts/Content';
import path from 'routes/Path';
import { HocChangePagination } from 'utils/HocChangePagination';
import { DEFAULT_PAGE_SIZE } from 'utils/constants/constant';
import { exportExcel_v2 } from 'utils/constants/exportExcel';
import { formatCurrency, formatDate } from 'utils/constants/functions';
import { icons } from 'utils/constants/icons';

const unit = 1;
const { SaveTwoTone, CloseCircleTwoTone } = icons;

interface ITableSalesInvoicePage {
  data: {
    items: any;
    pageInfo: any;
  };
  loading?: boolean;
  editIndex: number;
}

const { Text } = Typography;

export const TableSalesInvoicePage = memo(
  ({ data, loading, editIndex }: ITableSalesInvoicePage) => {
    const navigate = useNavigate();
    const [form] = useForm();

    const handleDownloadRowData = (index: number) => {
      const item = data?.items[index];

      exportExcel_v2(columns, [item], `Bảng kê bán hàng - ${item?.id}`);
    };

    const columns = useMemo(() => {
      return [
        {
          width: 50,
          title: 'STT',
          align: 'center',
          dataIndex: 'index',
          className: 'text-end align-top',
          fixed: 'left',
          // render: (_: any, __: any, index: number) =>
          //   index + 1 + pageSize * (page - 1),
        },
        {
          title: 'Mã SO',
          width: 100,
          dataIndex: 'SOId',
          className: 'text-start align-top',
          fixed: 'left',
        },
        // {
        //   title: 'Mã SO',
        //   width: 100,
        //   className: 'text-start align-top',
        //   render: (_, record) => {
        //     return (
        //       record?.torderProcess?.find(
        //         (item: any) => item?.processCode === 'SO',
        //       )?.processId ?? '-'
        //     );
        //   },
        // },
        {
          title: 'Mã đơn gộp',
          width: 120,
          dataIndex: 'mergeOrderIds',
          className: 'text-start align-top',
          fixed: 'left',
        },
        // {
        //   title: 'Mã đơn gộp',
        //   width: 250,
        //   className: 'text-start align-top',
        //   render: (_, record) => {
        //     const items = record?.tOrderSeparation
        //       ?.filter((item: any) => item?.tstatus?.id === 'OR02_03')
        //       .map((item: any) => item?.id);

        //     return items?.join('; ') || '-';
        //   },
        // },
        {
          title: 'Mã bảng kê',
          width: 160,
          dataIndex: 'id',
          className: 'text-start align-top',
          fixed: 'left',
          render: (value, record) => (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span>{value}</span>
              {record.isSyncFromSap && (
                <span
                  style={{
                    backgroundColor: '#002D62',
                    color: 'white',
                    borderRadius: '999px',
                    padding: '2px 12px',
                    fontSize: '12px',
                    display: 'inline-block',
                  }}
                >
                  SAP
                </span>
              )}
            </div>
          ),
        },
        {
          title: 'Mã đơn tách',
          width: 150,
          dataIndex: 'seperateOrderIds',
          className: 'text-start align-top',
        },
        // {
        //   title: 'Mã đơn tách',
        //   width: 250,
        //   dataIndex: 'seperateOrderIds',
        //   className: 'text-start align-top',
        //   render: (_, record) => {
        //     const items = record?.tOrderSeparation
        //       ?.filter((item: any) => item?.tstatus?.id === 'OR02_01')
        //       .map((item: any) => item?.id);

        //     return items?.join('; ') || '-';
        //   },
        // },
        // {
        //   title: 'Khách hàng',
        //   width: 150,
        //   // dataIndex: 'customerId',
        //   dataIndex: 'childCustomerId',
        //   className: 'text-start align-top',
        // },
        // {
        //   title: 'Tên khách hàng',
        //   width: 250,
        //   dataIndex: ['tchildcustomer', 'storeName'],
        //   // dataIndex: ['tcustomer', 'storeName'],
        //   className: 'text-start align-top',
        // },
        // {
        //   title: 'Mã KH cha',
        //   width: 100,
        //   dataIndex: 'customerId',
        //   className: 'text-start align-top',
        // },
        // {
        //   title: 'Mã KH check in',
        //   width: 120,
        //   dataIndex: 'customerCheckInId',
        //   className: 'text-start align-top',
        // },
        {
          title: 'Khách hàng',
          width: 120,
          // dataIndex: ['customer', 'sapCustomerId'],
          className: 'text-start align-top',
          render: (value, record) => {
            return record.tchildCustomer == null
              ? record.tcustomer?.sapCustomerId
              : record.tchildCustomer.sapCustomerId;
          },
        },
        {
          title: 'Tên khách hàng',
          width: 250,
          // dataIndex: ['customer', 'storeName'],
          // dataIndex: ['tcustomer', 'storeName'],
          className: 'text-start align-top',
          render: (value, record) => {
            return record.tchildCustomer == null
              ? record.tcustomer?.storeName
              : record.tchildCustomer.storeName;
          },
        },
        {
          title: 'Mã KH cha',
          width: 100,
          dataIndex: ['tcustomer', 'sapCustomerId'],
          className: 'text-start align-top',
        },
        {
          title: 'Mã KH check in',
          width: 120,
          dataIndex: ['tcustomer', 'sapCustomerId'],
          className: 'text-start align-top',
        },
        {
          title: 'Thành tiền công',
          width: 150,
          dataIndex: 'totalProcessPrice',
          className: 'align-top',
          type: 'number',
          align: 'right',
          currency: 'vi-VN',
          unit: unit,
          render: (value) => {
            return value !== null || value !== undefined
              ? formatCurrency({ value, round: true })
              : '-';
          },
        },
        {
          title: 'Thành tiền món',
          width: 150,
          dataIndex: 'totalPrice',
          className: 'align-top',
          type: 'number',
          align: 'right',
          currency: 'vi-VN',
          unit: unit,
          render: (value) => {
            return value !== null || value !== undefined
              ? formatCurrency({ value, round: true })
              : '-';
          },
        },
        {
          title: 'Thành tiền sau CK',
          width: 150,
          dataIndex: 'finalPriceSap',
          className: 'align-top',
          type: 'number',
          align: 'right',
          currency: 'vi-VN',
          unit: unit,
          render: (value) => {
            return value !== null || value !== undefined
              ? formatCurrency({ value, round: true })
              : '-';
          },
        },
        {
          title: 'Loại bảng kê',
          width: 100,
          dataIndex: 'orderTypeName',
          className: 'text-start align-top',
        },
        {
          title: 'SL Sản phẩm',
          width: 100,
          dataIndex: 'quantity',
          className: 'align-top',
          align: 'right',
        },
        {
          title: 'T.L vàng',
          width: 150,
          dataIndex: 'goldWeightOfStool',
          className: 'align-top',
          align: 'right',
          currency: 'vi-VN',
          unit: unit,
          render: (value) => {
            return value ? formatCurrency({ value, round: true }) : '-';
          },
        },
        {
          title: 'HĐĐT',
          width: 200,
          dataIndex: 'EInvoiceId',
          className: 'text-start align-top',
        },
        // {
        //   title: 'HĐĐT',
        //   width: 200,
        //   dataIndex: 'EInvoiceId',
        //   className: 'text-start align-top',
        //   render: (_, record) => {
        //     const EInoivce = record?.torderProcess?.find(
        //       (item: any) => item?.processCode === 'EINVOICE',
        //     );

        //     return EInoivce?.processId ?? '-';
        //   },
        // },
        {
          //
          title: 'Tên kế toán',
          width: 150,
          dataIndex: '2',
          className: 'text-start align-top',
        },
        {
          //
          title: 'Kế toán xác nhận',
          width: 150,
          dataIndex: '3',
          className: 'text-start align-top',
        },
        {
          //
          title: 'Thời gian kế toán xác nhận',
          width: 250,
          dataIndex: '3',
          className: 'text-start align-top',
        },
        {
          //
          title: 'Thủ quỹ xác nhận',
          width: 150,
          dataIndex: '3',
          className: 'text-start align-top',
        },
        {
          //
          title: 'Thời gian thủ quỹ xác nhận',
          width: 250,
          dataIndex: '3',
          className: 'text-start align-top',
        },
        {
          title: 'Chi nhánh',
          dataIndex: 'plantId',
          className: 'align-top',
          width: 100,
          align: 'center',
        },
        {
          title: 'Trạng thái',
          width: 100,
          dataIndex: 'orderStatusSyn',
          className: 'text-start align-top',
        },
        {
          title: 'Người tạo',
          width: 100,
          dataIndex: 'createName',
          className: 'text-start align-top',
        },
        {
          title: 'Ngày tạo',
          width: 200,
          dataIndex: 'createDate',
          type: 'date',
          align: 'left',
          className: 'align-top',
          render: (value) => {
            return value && formatDate(value);
          },
        },
        {
          title: 'Người cập nhật',
          width: 100,
          dataIndex: 'modifyName',
          className: 'text-start align-top',
        },
        {
          title: 'Ngày cập nhật',
          width: 200,
          dataIndex: 'modifyDate',
          type: 'date',
          align: 'left',
          className: 'align-top',
          render: (value) => {
            return value && formatDate(value);
          },
        },
        {
          fixed: 'right',
          align: 'center',
          width: 80,
          // width: 100,
          render: (_: any, record: any, index: number) =>
            editIndex == index ? (
              <Space size={'middle'} className="text-lg ">
                <ButtonAction tooltip="Lưu" onClick={() => console.log('save')}>
                  <SaveTwoTone style={{ fontSize: 20 }} />
                </ButtonAction>
                <ButtonAction
                  tooltip="Huỷ"
                  onClick={() => console.log('cancel')}
                >
                  <CloseCircleTwoTone style={{ fontSize: 20 }} />
                </ButtonAction>
              </Space>
            ) : (
              <Space size={'middle'} className="text-lg ">
                <ButtonAction
                  tooltip="Xem chi tiết"
                  onClick={() => {
                    navigate(
                      `${path.SALES_INVOICE_DETAIL}?orderId=${record?.id}&orderTypeId=${record?.orderTypeId}`,
                    );
                    // navigate(path.SALES_INVOICE_DETAIL, {
                    //   state: {
                    //     orderId: record?.id,
                    //     orderTypeId: record?.orderTypeId,
                    //   },
                    // });
                  }}
                >
                  <EyeIcon />
                </ButtonAction>
                {/* <ButtonAction
                  tooltip="Chỉnh sửa"
                  onClick={() => console.log(record, index)}
                >
                  {editIndex === -1 ? <EditIcon /> : <EditGrayIcon />}
                </ButtonAction>
                <ButtonAction
                  tooltip=""
                  onClick={() => console.log(record, index)}
                >
                  <Minus />
                </ButtonAction> */}
                {/* <ButtonAction
                  tooltip="Tải xuống"
                  onClick={() => handleDownloadRowData(index)}
                >
                  <DownloadIcon />
                </ButtonAction> */}
              </Space>
            ),
        },
      ] as ColumnsTypeCustom;
    }, [data]);

    return (
      <Content>
        <Form form={form}>
          <TableComponent
            columns={columns}
            dataSource={data?.items}
            expandable={{
              expandIconColumnIndex: 3,
              expandIcon: ({ expanded, onExpand, record }) => {
                const canExpand = record.children && record.children.length > 0;
                const svgClasses =
                  'inline cursor-pointer hover:bg-blue text-main';
                const buttonClasses = '!inline-flex mr-[6px]';

                return canExpand ? (
                  expanded ? (
                    <ButtonAction className={buttonClasses}>
                      <MinusBordered
                        className={svgClasses}
                        onClick={(e) => onExpand(record, e as any)}
                      />
                    </ButtonAction>
                  ) : (
                    <ButtonAction className={buttonClasses}>
                      <PlusBordered
                        className={svgClasses}
                        onClick={(e) => onExpand(record, e as any)}
                      />
                    </ButtonAction>
                  )
                ) : null;
              },
            }}
            rowKey={(record: any) =>
              `${record?.id}_${record?.customerId}` || ''
            }
            loading={loading}
            scroll={{ x: 5000 }}
            pagination={{
              disabled: editIndex !== -1,
              current: data?.pageInfo?.currentPage || 1,
              pageSize: data?.pageInfo?.itemsPerPage || DEFAULT_PAGE_SIZE,
              total: data?.pageInfo?.totalItems,
              onChange: HocChangePagination(),
            }}
          />
        </Form>
      </Content>
    );
  },
);
